<template>
  <div class="layout-header">
    <div>
      <img class="logo" src="../assets/img/layout/logo.png" alt="" />
    </div>
    <div class="layout-header-r">
      <div class="layout-header-r-c">
        <img class="icon" src="../assets/img/layout/icon.png" alt="" />
        <span>{{this.$store.state.globalAddress.slice(0,6) +"***" +this.$store.state.globalAddress.slice(38,42)}}</span>
        <img class="arrow" src="../assets/img/layout/arrow.png" alt="" />
      </div>

      <div class="lang">
        <Popover class="lang-popover" v-model="langShow">
          <div class="lang-popup">
            <div :class="{ active: $i18n.locale === 'zh' }" @click="handleLang('zh')">
              {{ $t('header.lang.zh') }}
            </div>
            <div :class="{ active: $i18n.locale === 'zh-TW' }" @click="handleLang('zh-TW')">
              {{ $t('header.lang.zhTW') }}
            </div>
            <div :class="{ active: $i18n.locale === 'en' }" @click="handleLang('en')">
              {{ $t('header.lang.en') }}
            </div>
            <div :class="{ active: $i18n.locale === 'ko' }" @click="handleLang('ko')">
              {{ $t('header.lang.ko') }}
            </div>
            <div :class="{ active: $i18n.locale === 'ja' }" @click="handleLang('ja')">
              {{ $t('header.lang.ja') }}
            </div>
          </div>
          <template #reference>
            <img @click="langShow = true" src="../assets/img/layout/langs.png" alt="" />
          </template>
        </Popover>
      </div>

      <div class="menu" @click="menuShow = true">
        <img src="../assets/img/layout/menu.png" alt="" />
      </div>
    </div>

    <Popup v-model="menuShow" class="menuPopup" get-container="#app" position="right">
      <div class="menu-header">
        <div class="logo">
          <img src="../assets/img/layout/logo.png" alt="" />
        </div>
      </div>

      <div class="menu-content">
        <div class="active">
          <img src="../assets/img/layout/menus/icon-home.png" alt="" />
          {{ $t('header.home') }}
        </div>
        <div>
          <img src="../assets/img/layout/menus/icon-alliance.png" alt="" />
          {{ $t('header.alliance') }}
        </div>
        <div>
          <img src="../assets/img/layout/menus/icon-mall.png" alt="" />
          {{ $t('header.mall') }}
        </div>
        <div>
          <img src="../assets/img/layout/menus/icon-me.png" alt="" />
          {{ $t('header.about') }}
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import { ActionSheet, Popover, Icon, Popup, Field } from "vant";
import { setLanguage } from "@/utils/cookies";
import { Locale } from "vant";
import { copyToClipboard } from "@/utils";


import Web3 from 'web3'

let web3

export default {
  name: "layout-header",
  components: {
    ActionSheet,
    Icon,
    Popup,
    Field,
    Popover,
  },
  data() {
    return {
      isLogin: true,
      show: false,
      show1: false,
      check: false,
      menuShow: false,
      langShow: false,
      linkShow: false,
      walletIcon: "",
      userName: "0x...",
      actions: [],
      checkItem: "",
    };
  },
  computed: {
    menuItem() {
      for (const section of this.menu) {
        const item = section.children.find(
          (child) => this.$route.name === child.path
        );
        if (item) return item;
      }
      return null;
    },
    menu() {
      return [
        {
          title: "header.trading",
          children: [
            { title: "header.dashboard", icon: "icon-dashboard", path: "home" },
            {
              title: "header.subscribeMatrix",
              icon: "icon-matrix",
              path: "staking",
            },
            {
              title: "header.portTaskCenter",
              icon: "icon-task",
              path: "port",
              badge: "+20",
            },
          ],
        },
        {
          title: "header.network",
          children: [
            {
              title: "header.apiBinding",
              icon: "icon-apibind",
              path: "bindapi",
            },
            {
              title: "header.gridTree",
              icon: "icon-internet",
              path: "internet",
            },
          ],
        },
        {
          title: "header.account",
          children: [
            { title: "header.documents", icon: "icon-doc", path: "whitePaper" },
            { title: "header.personalCenter", icon: "icon-user", path: "me" },
          ],
        },
      ];
    },
  },
  watch: {
    "$route.path"(path) {
      this.menuShow = false;
    },
  },
  methods: {
    toggleSound() {
      this.$store.commit("toggleSound");
    },
    handleLink() {
      if (this.isLogin) {
        this.linkShow = !this.linkShow;
      } else {
        this.linkShow = false;
      }
    },
    handleMenu(item) {
      this.menuShow = false;
      if (item.path) {
        this.$router.push({
          name: item.path,
        });
      }
      if (item.lang) {
        this.$i18n.locale = item.lang;
        setLanguage(item.lang);
        Locale.use(item.lang, this.$i18n.messages[item.lang]);
      }
    },
    handleLang(lang) {
      this.$i18n.locale = lang;
      setLanguage(lang);
      Locale.use(lang, this.$i18n.messages[lang]);
      this.langShow = false;
    },
    copy(text) {
      copyToClipboard(text);
    },
     async userlogin(){
            var that = this;
            if(typeof window.ethereum !='undefined'  ){
                //console.log('安装了插件')
                web3 = new Web3(window.ethereum);
                const chainId = await window.ethereum.request({
                    method: 'eth_chainId'
                })
                if(chainId!='0x38'){
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x38' }] // BSC
                    })
                }
                ethereum.request({ method: 'eth_requestAccounts' }).then(handleAccountsChanged=>{
                  that.userName = Web3.utils.toChecksumAddress(handleAccountsChanged[0]);
                  that.$store.state.globalAddress = that.userName;
                  that.$emit("ready")
                })
            }
            else{
              //console.log('没有安装插件')
            }
        },
  },
  mounted(){
      this.shareLeaderCode = this.$route.query.share
      if(this.$store.state.globalAddress =="" || !this.$store.state.islogin){
        this.userlogin()
      }
  }
};
</script>
<style lang="less">
.layout-header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  align-items: center;
  width: 375px;
  height: 44px;
  padding: 0 15px 0;
  top: 0;
  z-index: 22;
  backdrop-filter: blur(50px);
  --webkit-filter: blur(50px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  >div {
    display: flex;

    .logo {
      width: 117px;
      height: 28px;
    }

    .menu {
      width: 24px;
      height: 24px;
    }
  }

  &-r {
    display: flex;

    img {
      width: 24px;
      height: 24px;
    }

    &-c {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 80px;
      background: #f9f9f8;
      border: 1px solid #f0eeee;
      border-radius: 12px;
      padding: 2px;

      span {
        margin: 0 6px 0 4px;
      }

      .icon {
        width: 20px;
        height: 20px;
      }

      .arrow {
        width: 6px;
        height: 6px;
      }
    }

    .lang {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 12px;
    }

    .menu {
      margin-left: 12px;
    }
  }
}

.lang-popup {
  padding: 8px;
  font-size: 13px;
  color: #808080;
  line-height: 18px;

  >div {
    padding: 7px 0;
    text-align: center;
    min-width: 100px;
    cursor: pointer;
    &.active {
      color: #030303;
      background: #f9f9f8;
      border-radius: 8px;
    }
  }
}

.menuPopup {
  width: 215px;
  height: 100%;
  background: #fff;
  padding: 46px 15px 0;
  overflow-y: auto;

  .menu-header {
    margin-bottom: 16px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      img {
        width: 129px;
        height: 31px;
      }
    }
  }

  .menu-content {
    >div {
      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }

      font-size: 14px;
      color: #030303;
      line-height: 16px;
      display: flex;
      align-items: center;
      padding: 12px 18px;

      &.active {
        background: #F8F8F8;
        border-radius: 10px;
      }
    }
  }
}
</style>